<template>
    <div :class="isDamOrigin ? 'sensor-icon-wrapper-reactangle': 'sensor-icon-wrapper'">
        <div class="">
            <div class="mb-2">
                <a href="#" class="sensor-graph-direct-link">
                    <div class="icon-circle" :class="isDamOrigin ? 'icon-rectangle': ''">
                        <SvgIcon
                            :title="sensorName"
                            :alt="sensorName"
                            :name="getImgName"
                            :width="12"
                            :height="12"
                        />
                    </div>
                </a>
            </div>
            <div class="icon-text small">
                <a href="#" class="sensor-graph-direct-link">
                    <span>
                        <span class="icon-text-value">{{ computedValue }}</span>
                        &nbsp;
                        <span class="icon-text-metrics"> {{ computedMetric }}</span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {iconsUnits} from "../../constants/sensors-constants";
    // components
    import SvgIcon from '../shared/SvgIcon';

    /**
     * Icon+text showing the sensor's data - type, value, metric
     */

    export default {
        name: "RightPanelContainerIcon",
        components: {
            SvgIcon
        },
        props: {
            sensorIconKey: String,
            sensorName: String,
            sensorData: [Number, String],
            isDamOrigin: Boolean
        },
        data() {
            return {
                iconsUnits
            }
        },
        computed: {
            getImgName() {
                let imgName = '';
                imgName = iconsUnits[this.sensorIconKey].icon;

                return imgName;
            },
            /**
             * The sensor can have a specific value.
             * Like wind direction: angle in degrees, metric, angle as word
             * @returns {*}
             */
            computedValue() {
                // if it is a string, it is possible that it is wind/air direction
                // but converted to one of the sixteen possible directions
                if (typeof  this.sensorData === 'string') {
                    if (this.$i18n.te(`directions.${this.sensorData}`)) {
                        return this.$i18n.t(`directions.${this.sensorData}`);
                    }
                }
                return this.sensorData;
            },
            /**
             * Returns the localized metric.
             * @returns {TranslateResult|VueI18n.TranslateResult|*}
             */
            computedMetric() {
                return this.$t(this.iconsUnits[this.sensorIconKey].unit);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .sensor-icon-wrapper {
        max-width: 52px;
        max-height: 46px;
        cursor: pointer;

        .sensor-graph-direct-link {
            display: flex;
            justify-content: center;
            align-items: baseline;
            color: $purpleColor;
            text-decoration: none;
            &:hover {
                color: $purpleColor;
            }
        }
        .icon-circle {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 22px;
            height: 22px;
            background-color: $lightPurple;
            border-radius: 50%;
        }

        .icon-rectangle {
            border-radius: 0%;
            background-color: transparent;
        }

        .icon-text {
            text-align: center;
            letter-spacing: 0;
            color: $purpleColor;
            opacity: 1;

            .icon-text-value {
                font: 800 14px/16px Nunito, sans-serif;
            }
            .icon-text-metrics {
                font: 400 12px/16px Nunito, sans-serif;
            }
        }

        &-reactangle {
            display: flex;
            justify-content: center;

            & > div {
                display: flex;
                border: 1px solid $lightGrey;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
                // max-width: 65px;
                min-height: 80px;
                min-width: 60px;
                margin: 5px 2px;
            }

            svg {
                width: 24px;
                height: 22px;
            }
            .icon-text-value {
                font-weight: $font-weight-normal !important;
            }
        }
    }
</style>